module.exports = __webpack_public_path__ + "img/journal-x.93eb3826.svg";